import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'app-return-validation',
  templateUrl: './return-validation.component.html',
  styleUrls: ['./return-validation.component.scss']
})
export class ReturnValidationComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<ReturnValidationComponent>) {
  }

  ngOnInit() {
  }

  valid() {
    this.dialogRef.close(true);
  }

  refuse() {
    this.dialogRef.close(false);
  }
}
